import { getUrlExtension } from "./strings.js";

/**
 *
 * @param filePreviewElement Html element to bind and render on
 * @param mediaURL Media url to load
 * @param isVideo Flag to render video / image from
 */
export function displayMedia(
  filePreviewElement: HTMLVideoElement | HTMLImageElement,
  mediaURL: string,
  isVideo: boolean = false
) {
  filePreviewElement.src = mediaURL;
  if (isVideo && filePreviewElement instanceof HTMLVideoElement) {
    filePreviewElement.controls = true; // no controls since gifs and autoplay
    filePreviewElement.autoplay = true;
    filePreviewElement.muted = false;
  }
}

/**
 *
 * @param url Url to test for being a video type
 * @param imageExtensions Extensions that are considered images
 * @param wasItem No clue tbh
 * @returns Boolean flag that indicates if the url was a video type
 */
export function isMediaType(
  url: string,
  imageExtensions: readonly string[],
  wasItem: boolean = false
): boolean {
  let ext = getUrlExtension(url);
  if (wasItem) {
    ext = url.split(".").pop()?.toUpperCase() as
      | "JPG"
      | "JPEG"
      | "JFIF"
      | "GIF"
      | "PNG"
      | "MP3"
      | "MP4"
      | "";
  }

  return imageExtensions.includes(ext);
}
